import { render, staticRenderFns } from "./OrgDeptSelector.vue?vue&type=template&id=2121603a&scoped=true"
import script from "./OrgDeptSelector.vue?vue&type=script&lang=js"
export * from "./OrgDeptSelector.vue?vue&type=script&lang=js"
import style0 from "./OrgDeptSelector.vue?vue&type=style&index=0&id=2121603a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121603a",
  null
  
)

export default component.exports